import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const PenitensiRekapPage = () => {
  const navigate = useNavigate();
  
  // Dummy data for penitensi
  const penitensiData = [
    {
      id: 1,
      tanggal: '25 April 2025',
      kategori: 'Sikap',
      judulRefleksi: 'Cabut rumput',
      durasi: '2 jam',
      pSikap: '+20',
      pKompen: null
    },
    {
      id: 2,
      tanggal: '20 April 2025',
      kategori: 'Kompen',
      judulRefleksi: 'Membersihkan kelas',
      durasi: '3 jam',
      pSikap: null,
      pKompen: '+9'
    },
    {
      id: 3,
      tanggal: '15 April 2025',
      kategori: 'Sikap',
      judulRefleksi: 'Lelayu simbah',
      durasi: '7 jam',
      pSikap: '+25',
      pKompen: null
    },
    {
      id: 4,
      tanggal: '10 April 2025',
      kategori: 'Kompen',
      judulRefleksi: 'Membantu perpustakaan',
      durasi: '5 jam',
      pSikap: null,
      pKompen: '+15'
    },
    {
      id: 5,
      tanggal: '5 April 2025',
      kategori: 'Sikap',
      judulRefleksi: 'Menyiram tanaman',
      durasi: '1 jam',
      pSikap: '+10',
      pKompen: null
    },
    {
      id: 6,
      tanggal: '1 April 2025',
      kategori: 'Kompen',
      judulRefleksi: 'Piket kebersihan',
      durasi: '2 jam',
      pSikap: null,
      pKompen: '+7'
    },
    {
      id: 7,
      tanggal: '25 Maret 2025',
      kategori: 'Sikap',
      judulRefleksi: 'Membersihkan aula',
      durasi: '4 jam',
      pSikap: '+30',
      pKompen: null
    },
    {
      id: 8,
      tanggal: '20 Maret 2025',
      kategori: 'Kompen',
      judulRefleksi: 'Membantu di kantin sekolah',
      durasi: '3 jam',
      pSikap: null,
      pKompen: '+10'
    },
    {
      id: 9,
      tanggal: '15 Maret 2025',
      kategori: 'Sikap',
      judulRefleksi: 'Membersihkan lapangan',
      durasi: '3 jam',
      pSikap: '+20',
      pKompen: null
    },
    {
      id: 10,
      tanggal: '10 Maret 2025',
      kategori: 'Kompen',
      judulRefleksi: 'Kerja bakti lingkungan',
      durasi: '5 jam',
      pSikap: null,
      pKompen: '+14'
    }
  ];
  
  return (
    <PageContainer>
      <PageHeader>
        <BackButton onClick={() => navigate('/rekap')}>
          <span>←</span> Kembali
        </BackButton>
        <h1>Catatan Penitensi</h1>
        <p>Rekap penitensi dan perolehan poin</p>
      </PageHeader>
      
      <TableContainer>
        <DataTable>
          <thead>
            <tr>
              <th>No</th>
              <th>Tanggal</th>
              <th>Kategori</th>
              <th>Judul Refleksi</th>
              <th>Durasi</th>
              <th>P. Sikap</th>
              <th>P. Kompen</th>
            </tr>
          </thead>
          <tbody>
            {penitensiData.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.tanggal}</td>
                <td>
                  <KategoriTag $kategori={item.kategori.toLowerCase()}>
                    {item.kategori}
                  </KategoriTag>
                </td>
                <td>{item.judulRefleksi}</td>
                <td>{item.durasi}</td>
                <td>
                  {item.pSikap && (
                    <PoinValue positive={true}>
                      {item.pSikap}
                    </PoinValue>
                  )}
                </td>
                <td>
                  {item.pKompen && (
                    <PoinValue positive={true}>
                      {item.pKompen}
                    </PoinValue>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </DataTable>
      </TableContainer>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  padding: 1.5rem;
  max-width: 1280px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;
  position: relative;
  
  h1 {
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 0.5rem;
    text-align: center;
  }
  
  p {
    color: var(--text-light);
    text-align: center;
    font-size: 0.95rem;
  }
`;

const BackButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  color: var(--primary);
  font-weight: 500;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  margin-bottom: 1rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  span {
    margin-right: 0.5rem;
    font-size: 1.2rem;
  }
  
  &:hover {
    background-color: var(--primary);
    color: white;
  }
`;

const TableContainer = styled.div`
  background-color: var(--background);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid var(--border);
  }
  
  th {
    background-color: var(--background-light);
    font-weight: 600;
    color: var(--text-dark);
  }
  
  tr:last-child td {
    border-bottom: none;
  }
  
  tr:hover td {
    background-color: rgba(0, 0, 0, 0.01);
  }
  
  @media (max-width: 768px) {
    display: block;
    overflow-x: auto;
    
    th, td {
      padding: 0.75rem;
    }
  }
`;

const KategoriTag = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: ${props => props.$kategori === 'sikap' ? 'var(--warning-light)' : 'var(--info-light)'};
  color: ${props => props.$kategori === 'sikap' ? 'var(--warning-dark)' : 'var(--info-dark)'};
`;

const PoinValue = styled.span`
  font-weight: 600;
  color: ${props => props.positive ? '#00a389' : '#dc3545'};
`;

export default PenitensiRekapPage;